import React from "react";
import Footer from "../../components/Footer_/Footer";
import AboutSec from "../../components/AboutSec_/AboutSec";
import CommonHero from "../../components/CommonHero_/CommonHero";
import CallToAction from "../../components/CallToAction/CallToAction";
import Reviews from "../../components/Reviews_/Reviews";
import { Helmet } from "react-helmet";

const Partners = () => {
  return (
    <>
     <Helmet>
        <title>
          Our Partners: EG4, Canadian Solar EP Cube 2.0, EcoFlow | TRU Off Grid
        </title>
        <link rel="canonical" href="https://truoffgrid.com/partners" />
        <meta
          name="description"
          content="Solar and battery storage installers in Milton, Ontario. EG4, EP Cube 2.0 and EcoFlow systems for homes, cottages, off-grid properties and job sites, with a licensed master electrician on staff."
        />
      </Helmet>
      <CommonHero
        minHeight={true}
        heading="Our"
        span="Partners"
        text="TRU Off Grid partners only with high-quality companies and brands that stand behind their technology. EG4, Canadian Solar and EcoFlow manufacture innovative, proven products backed by strong warranties, and they align with our mission: to provide Canadians with high-quality, sustainable, clean energy solutions."
      />
       <AboutSec
        heading={"EG4 ELECTRONICS"}
        subHeading={"10-YEAR BATTERY WARRANTY"}
        text={`EG4 builds the hybrid and off-grid inverters, GridBOSS controllers and 14.3 kWh LiFePO4 batteries behind most of our whole-home and off-grid installs. EG4 batteries carry a 10-year warranty, scale by adding modules, and come in indoor and all-weather outdoor versions. Our crew has installed EG4 systems in homes, off-grid cottages, workshops, scale houses and commercial power containers across Ontario.`}
        img={"/images/eg4-12000xp-and-batteries.jpg"}
        imgBorderRad={true}
        />
      <AboutSec
        heading={"EP CUBE 2.0 BY CANADIAN SOLAR"}
        subHeading={"10-YEAR WARRANTY"}
        text={`Since 2022, TRU Off Grid has partnered with Grid Iron Power and Canadian Solar, maker of the EP Cube residential energy storage system. We now install the EP Cube 2.0, an all-in-one hybrid inverter and battery from 5 to 40 kWh per unit. We and our customers have received excellent technical and warranty support from Canadian Solar on every install, our installation team has received installer training from Canadian Solar, and the partnership lets us help homeowners access virtual power plant (VPP) programs and incentives.`}
        img={"/images/ep-cube-20-partner-block-garage-install.jpg"}
        reverse={true}
        imgBorderRad={true}
      />
      <AboutSec
        subHeading={"5 Year Warranty"}
        heading={"ECOFLOW"}
        text={`EcoFlow makes portable power stations and modular home backup systems, backed by a 5-year warranty. We carry EcoFlow DELTA power stations at our Milton shop and install EcoFlow critical-load backup systems for homes and cottages.`}
        img={"/images/ecoflow-partner-block-delta-pro-ultra-and-smart-home-panel-2.jpg"}
        imgBorderRad={true}
        padding="80px 0px 80px 0px"
      />
      <Reviews />
      <Footer newsletter={true} />
    </>
  );
};

export default Partners;
